var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-0 pb-3 mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center text-left pt-2" }, [
        _c(
          "div",
          {
            staticClass: "col-md-6 center mb-3 text-center pointer selectBlock",
            class: { blockActive: _vm.flow == "cdp" },
            on: {
              click: function($event) {
                _vm.flow = "cdp"
              }
            }
          },
          [
            _c(
              "h1",
              { staticClass: "mt-4", class: { grey: _vm.flow == "poste" } },
              [_c("b", [_vm._v(" CDP ")])]
            ),
            _vm._v(" "),
            _c("h4", { class: { grey: _vm.flow == "poste" } }, [
              _vm._v("Cassa Depositi e Prestiti")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-md-6 center mb-3 text-center pointer selectBlock",
            class: { blockActive: _vm.flow == "poste" },
            on: {
              click: function($event) {
                _vm.flow = "poste"
              }
            }
          },
          [
            _c(
              "h1",
              { staticClass: "mt-4", class: { grey: _vm.flow == "cdp" } },
              [_c("b", [_vm._v(" Poste Italiane ")])]
            ),
            _vm._v(" "),
            _c("h4", { class: { grey: _vm.flow == "cdp" } }, [
              _vm._v(" BancoPosta Affari")
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12 center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "p",
            { class: { red: _vm.totalDisposal < _vm.min_disposal_price_cdp } },
            [
              _vm._v(" Importo minimo di Cessione "),
              _c("b", [
                _vm._v(
                  "€ " +
                    _vm._s(_vm._f("formatNumber")(_vm.min_disposal_price_cdp)) +
                    " "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "black" }, [
                _vm._v(
                  "( Solo dopo aver raggiunto questo importo, anche cumulando più Pratiche, potrai cedere il credito )"
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 pr-md-5 pl-md-5 pt-4" }, [
          _c(
            "div",
            { staticClass: "buttonTextCont widthfull lightGreen mt-5" },
            [
              _c("h1", { staticClass: "widthFull mt-0 center pb-0 mb-0" }, [
                _c("b", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.countPractices - _vm.countPracticesNextMonth)
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-primary btn-green btnRed btn-sm  uppercase widthFull",
              on: {
                click: function($event) {
                  _vm.filter = ""
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "d-none d-md-inline white" },
                [
                  _vm._v(" Pratiche con credito cedibile a "),
                  _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttonTextCont widthfull lightGreen mt-5" },
            [
              _c("h1", { staticClass: "widthFull mt-0 center pb-0 mb-0" }, [
                _c(
                  "b",
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: "euro-sign", size: "sm" }
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatNumber")(_vm.countValues)) +
                        "\n          "
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-primary btn-green btnRed btn-sm  uppercase widthFull",
              on: {
                click: function($event) {
                  _vm.filter = ""
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "d-none d-md-inline white" },
                [
                  _vm._v(" Importo totale del credito cedibile a "),
                  _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "widthFull center" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "scroll-to",
                    rawName: "v-scroll-to",
                    value: { el: "#nextMonth", offset: -145 },
                    expression: "{ el: '#nextMonth', offset: -145 }"
                  }
                ],
                staticClass: "btn btn-primary btnBlue btn-sm mt-5",
                attrs: { type: "button" }
              },
              [_vm._v(" Pratiche con credito cedibile dal mese successivo ")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("p", { staticClass: "center mt-0 mb-0" }, [
            _vm._v(
              "Seleziona le Pratiche per le quali vuoi avviare la cessione del credito "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selectListBox" },
            [
              _vm.arrayPracticesAvailable.length
                ? _vm._l(_vm.arrayPracticesAvailable, function(item, index) {
                    return _c("h5", { staticClass: "pb-0 pt-0 mt-0" }, [
                      _c("div", { staticClass: "form-check pb-0 mb-0" }, [
                        _c("input", {
                          staticClass: "form-check-input pb-0 mb-0",
                          attrs: {
                            disabled: _vm.moment().date() < 11,
                            type: "checkbox",
                            value: "",
                            id: "box_" + index
                          },
                          domProps: {
                            checked:
                              _vm.disposalArray[item.id] &&
                              _vm.moment().date() >= 11
                                ? true
                                : false
                          },
                          on: {
                            change: function($event) {
                              return _vm.selectItemForDisposal(item, $event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "form-check-label custLabelFontSize pointer pb-0 mb-0",
                            attrs: { for: "box_" + index }
                          },
                          [
                            _vm._v("\n              Pratica N. "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(item.code))
                            ]),
                            _vm._v(
                              "\n              del " +
                                _vm._s(
                                  _vm
                                    .moment(item.created_at)
                                    .format("DD-MM-YYYY")
                                ) +
                                "\n              di "
                            ),
                            _c("b", [
                              _vm._v(
                                " " +
                                  _vm._s(item.client_lastname) +
                                  "  " +
                                  _vm._s(item.client_name) +
                                  " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-1" }, [
                              _c("b", [_vm._v(_vm._s(item.bonus))]),
                              _vm._v(" Importo di Cessione : "),
                              _c("b", [
                                _vm._v(
                                  "€ " +
                                    _vm._s(
                                      _vm._f("formatNumber")(item.finalAmmount)
                                    )
                                )
                              ])
                            ])
                          ]
                        )
                      ])
                    ])
                  })
                : [
                    _c("h5", { staticClass: "pb-0 pt-0 mt-0" }, [
                      _c("div", { staticClass: "form-check pb-0 mb-0" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "form-check-label custLabelFontSize pointer pb-0 mb-0",
                            attrs: { for: "box_1231231231" }
                          },
                          [
                            _vm._v(
                              "\n              No ci sono pratiche disponibili per cessione\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row pt-4 pb-4" }, [
            _c(
              "div",
              { staticClass: "col-md-12 center pb-4" },
              [
                _vm._v("\n          Importo totale del credito cedibile a "),
                _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                _vm._v(" "),
                _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e(),
                _vm._v(" delle Pratiche selezionate: "),
                _c(
                  "b",
                  {
                    class: {
                      red: _vm.totalDisposal < _vm.min_disposal_price_cdp
                    }
                  },
                  [
                    _vm._v(
                      " € " +
                        _vm._s(_vm._f("formatNumber")(_vm.totalDisposal)) +
                        " "
                    )
                  ]
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btnBlue btn-sm",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.addAllItemToDisposal()
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.allChecked ? "Deseleziona tutte" : "Seleziona tutte"
                      ) +
                      " "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 center" },
              [
                (_vm.flow == "cdp" && _vm.flow_cdp_active) ||
                (_vm.flow == "poste" && _vm.flow_poste_active)
                  ? [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-sm btn-green btnRed",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.totalDisposal < _vm.min_disposal_price_cdp ||
                              _vm.moment().date() < 11
                          },
                          on: {
                            click: function($event) {
                              return _vm.addDisposal()
                            }
                          }
                        },
                        [_vm._v(" Avvia Cessione ")]
                      )
                    ]
                  : [
                      _vm.flow == "poste"
                        ? _c("a", {
                            staticClass:
                              "btn btn-primary btnYellow btn-sm white small",
                            attrs: { disabled: "" },
                            domProps: {
                              innerHTML: _vm._s(_vm.poste_not_active_text)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.flow == "cdp"
                        ? _c("a", {
                            staticClass:
                              "btn btn-primary btnYellow btn-sm white small",
                            attrs: { disabled: "" },
                            domProps: {
                              innerHTML: _vm._s(_vm.cdp_not_active_text)
                            }
                          })
                        : _vm._e()
                    ]
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center divider" }),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 pr-md-5 pl-md-5 pt-4" }, [
          _c(
            "div",
            { staticClass: "buttonTextCont widthfull lightYellow mt-5" },
            [
              _c("h1", { staticClass: "widthFull mt-0 center pb-0 mb-0" }, [
                _c("b", [_vm._v(" " + _vm._s(_vm.countPracticesNextMonth))])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-primary btnRed  btn-sm  uppercase widthFull",
              on: {
                click: function($event) {
                  _vm.filter = ""
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "d-none d-md-inline white" },
                [
                  _vm._v(" Pratiche con credito cedibile a "),
                  _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e(),
                  _vm._v(" dal mese successivo ")
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttonTextCont widthfull lightYellow mt-5" },
            [
              _c("h1", { staticClass: "widthFull mt-0 center pb-0 mb-0" }, [
                _c(
                  "b",
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: "euro-sign", size: "sm" }
                    }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("formatNumber")(_vm.countValuesNextMonth)
                        ) +
                        "\n          "
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-primary  btn-sm btnRed  uppercase widthFull",
              on: {
                click: function($event) {
                  _vm.filter = ""
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "d-none d-md-inline white" },
                [
                  _vm._v("Importo totale del credito cedibile a "),
                  _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e(),
                  _vm._v(" dal mese successivo ")
                ],
                2
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("h5", { staticClass: "mt-1 pt-4 center mb-3" }, [
            _vm._v("Elenco Pratiche con credito cedibile dal mese successivo")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selectListBox lightYellow" },
            [
              _vm.arrayPracticesNextMonth.length
                ? _vm._l(_vm.arrayPracticesNextMonth, function(item, index) {
                    return _c("h5", { staticClass: "pb-0 pt-0 mt-0" }, [
                      _c("div", { staticClass: "form-check pb-0 mb-0" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "form-check-label custLabelFontSize pointer pb-0 mb-0",
                            attrs: { for: "box_2" + index }
                          },
                          [
                            _vm._v("\n              Pratica N. "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(item.code))
                            ]),
                            _vm._v(
                              "\n              del " +
                                _vm._s(
                                  _vm
                                    .moment(item.created_at)
                                    .format("DD-MM-YYYY")
                                ) +
                                "\n              di "
                            ),
                            _c("b", [
                              _vm._v(
                                " " +
                                  _vm._s(item.client_lastname) +
                                  " " +
                                  _vm._s(item.client_name) +
                                  "  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-1" }, [
                              _c("b", [_vm._v(_vm._s(item.bonus))]),
                              _vm._v(" Importo di Cessione: "),
                              _c("b", [
                                _vm._v(
                                  "€ " +
                                    _vm._s(
                                      _vm._f("formatNumber")(item.finalAmmount)
                                    )
                                )
                              ])
                            ])
                          ]
                        )
                      ])
                    ])
                  })
                : [
                    _c("h5", { staticClass: "pb-0 pt-0 mt-0" }, [
                      _c("div", { staticClass: "form-check pb-0 mb-0" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "form-check-label custLabelFontSize pointer pb-0 mb-0",
                            attrs: { for: "box_1231231231" }
                          },
                          [
                            _vm._v(
                              "\n              No ci sono pratiche disponibili per cessione dal mese successivo\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12 center mt-3 pb-4" },
            [
              _vm._v("\n          Importo totale del credito cedibile a "),
              _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
              _vm._v(" "),
              _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e(),
              _vm._v(" dal mese successivo: "),
              _c(
                "b",
                {
                  class: { red: _vm.totalDisposal < _vm.min_disposal_price_cdp }
                },
                [
                  _vm._v(
                    " € " +
                      _vm._s(_vm._f("formatNumber")(_vm.countValuesNextMonth)) +
                      " "
                  )
                ]
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.editUser()
            }
          }
        },
        [_c("div", { staticClass: "row justify-content-center pt-4" })]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _c("b", [_vm._v("Riepilogo Pratiche disponibili per la Cessione (*)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "mt-1 pt-0 center mb-3" }, [
      _vm._v("Elenco Pratiche con credito cedibile "),
      _c("b", [_vm._v("dal giorno 11 del mese corrente")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-11 pb-3 " }, [
      _c("b", [_vm._v("* NOTA")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        " Nel caso di Ditte Individuali o in assenza di delega all'intermediario abilitato per le Società di capitali o di persone, le stesse dovranno provedere autonamente ad accettare nel proprio cassetto fiscale\n       i crediti ceduti dai loro clienti ( utenti finali ) per poter procedere alla cessione del credito.\n    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-12 center mt-4 ", attrs: { id: "nextMonth" } },
      [
        _c("h4", [
          _c("b", [
            _vm._v("Pratiche con credito cedibile dal mese successivo ")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-866a5c7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-866a5c7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cessioni/practicesToDo.vue
// module id = null
// module chunks = 